import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import httpService from '../services/http.service';
import { currency_format, t } from '../utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFullScreen, toogleFullScreen } from '../fullscreen';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import { ArrowRightIcon, XCircleIcon, Squares2X2Icon, ArrowPathIcon, ArrowLeftIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
const priceFilterList = ['Retail Prices', 'Wholesale Prices', 'Super Dealer Prices'];
class PointOfSale extends Component {
    constructor(props) {
        super(props);
        this.searchRequestId = 0;
        this.specialCustomerPrice = (prod) => {
            if (!this.state.customer)
                return prod.price || 0;
            if (this.state.customer.order_details.length == 0)
                return prod.price || 0;
            var newProd = this.state.customer.order_details.find(p => p.product_id === prod.id);
            if (!newProd)
                return prod.price || 0;
            return newProd.price || 0;
        };
        this.getCategories = () => {
            // console.log("ASDASD");
            httpService
                .get(`inventory/categories`)
                .then((response) => {
                this.setState({ categories: response.data.data });
            })
                .finally(() => {
                this.setState({ isLoadingCategories: false });
            });
        };
        this.getServices = () => {
            httpService
                .get(`inventory/services`)
                .then((response) => {
                this.setState({ services: response.data.data });
            })
                .catch((error) => {
                console.error('Error fetching services:', error);
                toast.error(t('Error fetching services', 'خطأ في جلب الخدمات'));
            });
        };
        this.getPaidAmount = () => {
            return Number((this.state.customerAmount || 0).toFixed(2));
        };
        this.storeOrder = (invoiceType = 'customer') => {
            var _b;
            for (let i = 0; i < this.state.cart.length; i++) {
                if (this.state.cart[i].in_stock - ((_b = this.state.cart[i].quantity) !== null && _b !== void 0 ? _b : 0) < 0) {
                    toast.error(t('Out of stock for ' + this.state.cart[i].name + '!', 'إنتهى من المخزن!'));
                    return;
                }
            }
            if (this.state.cart.length == 0) {
                toast.error(t('No items has been added!', 'لم يتم إضافة اية اصناف!'));
                return;
            }
            this.setState({ isLoading: true });
            var _deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                _deliveryCharge = this.isOrderDelivery() ? this.state.deliveryCharge || 0 : 0;
            }
            else {
                _deliveryCharge = this.state.deliveryCharge || 0;
            }
            const paidAmount = this.getPaidAmount();
            const isFullyPaid = paidAmount >= this.state.total;
            const selectedService = this.getSelectedService();
            this.setState({ lastSavedOrderId: null });
            httpService
                .post(`/order`, {
                customer: this.state.customer,
                cart: this.state.cart,
                subtotal: this.state.subtotal,
                total: this.state.total,
                tax_rate: this.state.tax || 0,
                vat_type: this.state.vatType,
                delivery_charge: _deliveryCharge,
                discount: this.state.discount || 0,
                remarks: this.state.remarks,
                type: this.state.orderType,
                tender_amount: paidAmount,
                return_amount: paidAmount - this.state.total,
                price_type: this.state.currentPrice || 0,
                paid: this.state.isPaid,
                is_quotation: this.state.isQuotation,
                invoice_type: invoiceType,
                service_id: selectedService ? selectedService.id : '',
                service_type: selectedService ? selectedService.service_type : '',
                service_price: selectedService ? selectedService.price : 0
            })
                .then((response) => {
                if (response.data) {
                    const orderId = response.data.order.id;
                    this.resetPos();
                    toast.info(t('Saved!', 'تم الحفظ'));
                    this.setState({ lastSavedOrderId: orderId }, () => {
                        if (invoiceType === 'government') {
                            this.printGovernmentInvoice(orderId);
                        }
                        else {
                            this.printInvoice(orderId);
                        }
                    });
                }
            })
                .finally(() => {
                this.setState({ isLoading: false });
                this.getCategories();
            });
        };
        this.reset = () => {
            Swal.fire({
                title: t('Reset?', 'إعادة ضبط'),
                text: t('Any unsaved changes will be lost', 'ستفقد أي تغييرات غير محفوظة'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('Reset?', 'إعادة ضبط'),
                cancelButtonText: t('Cancel', 'إلغاء')
            }).then(result => {
                if (result.isConfirmed) {
                    this.resetPos();
                }
            });
        };
        this.resetPos = () => {
            var settings = this.getAppSettings();
            this.setState({ products: [] });
            this.setState({ cart: [] });
            this.setState({ customers: [] });
            this.setState({ customer: undefined });
            this.setState({ customerName: null });
            this.setState({ customerEmail: null });
            this.setState({ customerMobile: null });
            this.setState({ customerCity: null });
            this.setState({ customerBuilding: null });
            this.setState({ customerStreet: null });
            this.setState({ customerFloor: null });
            this.setState({ customerApartment: null });
            this.setState({ showProducts: false });
            this.setState({ categoryName: '' });
            this.setState({ subtotal: 0 });
            this.setState({ deliveryCharge: settings.deliveryCharge });
            this.setState({ total: 0 });
            this.setState({ discount: settings.discount });
            this.setState({ tax: settings.taxRate });
            this.setState({ vatType: settings.vatType });
            this.setState({ searchValue: null });
            this.setState({ remarks: null });
            this.setState({ tenderAmount: 0 });
            this.setState({ returnAmount: 0 });
            this.setState({ customerAmount: 0 });
            this.setState({ isLoading: false });
            this.setState({ selectItem: 'first' });
            this.setState({ isPaid: true });
            this.setState({ isQuotation: false });
            this.setState({ selectedService: null });
            this.setState({
                customerSearch: '',
                customers: [],
                previousOrders: []
            });
        };
        this.togglePaidButton = () => {
            this.setState({ isPaid: !this.state.isPaid });
        };
        this.categoryClick = (category) => {
            this.setState({ showProducts: true });
            this.setState({ selectItem: category.id });
            this.setState({ products: category.products || [] });
            this.setState({ categoryName: category.name });
        };
        this.backClick = () => {
            this.setState({ showProducts: false });
            this.setState({ products: [] });
            this.setState({ categoryName: '' });
            this.setState({ selectItem: 'first' });
        };
        this.handleDiscountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var discountValue = value == '' ? undefined : Number(value);
            this.setState({ discount: discountValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleTaxChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var taxValue = value == '' ? undefined : Number(value);
            this.setState({ tax: taxValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleDeliveryChargeChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var deliveryChargeValue = value == '' ? undefined : Number(value);
            this.setState({ deliveryCharge: deliveryChargeValue }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPrice = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemQtyByClick = (event, item, qty) => {
            var value = qty;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = Number(value) || 1;
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.toggleFullScreen = () => {
            toogleFullScreen();
            this.setState({ isFullScreen: !this.state.isFullScreen });
        };
        this.goToDashboard = () => {
            window.location.href = '/';
        };
        this.calculateItemPrice = (item) => {
            let price = ((item.price || 0) * (item.quantity || 0) * (100 - Number(item.discount || 0))) / 100.0;
            if (item.vat_type === 'add')
                price = price + (price * Number(item.tax_rate)) / 100;
            else
                price = price - (price * Number(item.tax_rate)) / 100;
            return Number(price.toFixed(2));
        };
        this.calculateTotal = () => {
            let _total = 0;
            let _subtotal = 0;
            let _discount = 0;
            if (this.state.cart.length > 0) {
                this.state.cart.map((item) => {
                    let item_discount = 0;
                    item_discount = ((item.price || 0) * (item.quantity || 0) * (item.discount || 0)) / 100;
                    _subtotal += (item.price || 0) * (item.quantity || 0);
                    _discount += item_discount;
                });
            }
            let taxValue = 0;
            if (this.state.vatType == 'add') {
                if ((this.state.tax || 0) > 0 && (this.state.tax || 0) <= 100) {
                    taxValue = (Number(this.state.tax || 0) * Number(_subtotal)) / 100;
                }
            }
            var deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                if (this.isOrderDelivery()) {
                    deliveryCharge = Number(this.state.deliveryCharge || 0);
                }
            }
            else {
                deliveryCharge = Number(this.state.deliveryCharge || 0);
            }
            let servicePrice = 0;
            const selectedService = this.getSelectedService();
            if (selectedService) {
                servicePrice = Number(selectedService.price || 0);
            }
            _total = Number(_subtotal) + Number(taxValue) + Number(deliveryCharge) + Number(servicePrice) - Number(_discount || 0);
            this.setState({ subtotal: _subtotal });
            this.setState({ total: _total });
            this.setState({ tenderAmount: _total });
            this.setState({ discount: _discount });
        };
        this.getVat = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            var taxAmount = this.getTaxAmount();
            return Math.round(Number(grossAmount) - Number(taxAmount));
        };
        this.getTaxAmount = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            return Math.trunc(Number(grossAmount) / Number(Number(1) + Number(vat) / Number(100)));
        };
        this.getTotalTax = () => {
            let taxValue = 0;
            if (Number(this.state.tax || 0) > 0 && Number(this.state.tax || 0) <= 100) {
                taxValue = (Number(this.state.tax || 0) * Number(this.state.subtotal)) / 100;
            }
            return Number(taxValue);
        };
        this.getChangeAmount = () => {
            return (this.state.customerAmount || 0) - this.state.total;
        };
        this.handleTenderAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var tenderAmount = value == '' ? undefined : Number(value);
            this.setState({ tenderAmount: tenderAmount });
        };
        this.handleCustomerAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var customerAmount = value == '' ? undefined : Number(value);
            var paidAmount = customerAmount !== null && customerAmount !== void 0 ? customerAmount : 0;
            this.setState({
                customerAmount,
                returnAmount: paidAmount - this.state.total
            });
        };
        this.handleRemarksChange = (event) => {
            this.setState({ remarks: event.currentTarget.value });
        };
        this.removeItem = (item) => {
            let newCartItems = this.state.cart.filter(i => i.cartId != item.cartId);
            this.setState({ cart: newCartItems }, () => this.calculateTotal());
        };
        this.addToCart = (product) => {
            let existingItem = this.state.cart.find(item => item.id === product.id);
            if (existingItem) {
                existingItem.quantity = Number(existingItem.quantity || 0) + 1;
                this.setState({ cart: [...this.state.cart] }, () => {
                    this.calculateTotal();
                });
                if (this.state.hasaudio) {
                    new Audio('/audio/public_audio_ding.mp3').play();
                }
                return;
            }
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                description: product.description,
                image_url: product.image_url,
                price: this.state.currentPrice === 0 ? product.retailsale_price : product.wholesale_price,
                wholesale_price: product.wholesale_price,
                retailsale_price: product.retailsale_price,
                wholesale_barcode: product.wholesale_barcode,
                retail_barcode: product.retail_barcode,
                wholesale_sku: product.wholesale_sku,
                retail_sku: product.retail_sku,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: 1,
                vat_type: this.getAppSettings().vatType,
                tax_rate: 0,
                discount: 0,
                oem: product.oem,
                cost: product.cost
            };
            this.setState({ selectItem: 'first' });
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
            if (this.state.hasaudio) {
                new Audio('/audio/public_audio_ding.mp3').play();
            }
            if (this.state.customer) {
                // Only fetch if customer is selected
                this.fetchCustomerProductHistory(this.state.customer.id, product.id);
            }
        };
        this.handleSearchSubmit = (event) => {
            var _b;
            event.preventDefault();
            let search = this.state.searchValue;
            if (!search)
                return;
            let searchValue = search.trim();
            // Check if the barcode is 18 characters long
            if (searchValue.length === 18 && /^\d+$/.test(searchValue)) {
                // Extract values from barcode
                let flag = searchValue.substring(0, 1);
                let itemCode = searchValue.substring(1, 7);
                let weight = parseFloat(searchValue.substring(7, 12)) / 1000; // Convert to kg
                let totalPrice = parseFloat(searchValue.substring(12, 17)) / 100; // Convert to decimal
                // Calculate unit price per kg
                let unitPricePerKg = totalPrice / weight;
                console.log('Extracted Barcode Details:', { flag, itemCode, weight, totalPrice, unitPricePerKg });
                // Search for the product by matching the retail_barcode
                let foundProduct;
                this.state.categories.forEach(category => {
                    console.log('Category:', category);
                    let product = category.products.find(p => p.retail_barcode === itemCode);
                    if (product) {
                        foundProduct = product;
                    }
                });
                if (foundProduct) {
                    console.log('Product found:', foundProduct);
                    // Check if the product is already in the cart
                    let cartItem = this.state.cart.find(p => p.id === foundProduct.id);
                    if (cartItem) {
                        // Update quantity and price
                        cartItem.quantity = ((_b = cartItem.quantity) !== null && _b !== void 0 ? _b : 0) + weight;
                        cartItem.price = totalPrice;
                    }
                    else {
                        // Fix: Ensure all required properties are present
                        let newItem = {
                            cartId: uuid(),
                            id: foundProduct.id,
                            name: foundProduct.name,
                            full_name: foundProduct.full_name,
                            description: foundProduct.description,
                            image_url: foundProduct.image_url,
                            price: unitPricePerKg,
                            wholesale_price: foundProduct.wholesale_price,
                            retailsale_price: foundProduct.retailsale_price,
                            retail_barcode: foundProduct.retail_barcode,
                            wholesale_barcode: foundProduct.wholesale_barcode || '',
                            wholesale_sku: foundProduct.wholesale_sku || '',
                            retail_sku: foundProduct.retail_sku || '',
                            in_stock: foundProduct.in_stock,
                            track_stock: foundProduct.track_stock,
                            continue_selling_when_out_of_stock: foundProduct.continue_selling_when_out_of_stock,
                            quantity: weight,
                            vat_type: this.getAppSettings().vatType,
                            tax_rate: 0,
                            discount: 0,
                            cost: foundProduct.cost
                        };
                        this.setState({ cart: [...this.state.cart, newItem] }, () => {
                            this.calculateTotal();
                        });
                    }
                    // Clear search input
                    this.clearSearch();
                }
                else {
                    toast.error(t('Product not found!', 'لم يتم العثور على المنتج!'));
                }
                return;
            }
            // If barcode is not 18 digits, fallback to normal search
            let productFound = 0;
            this.state.categories.forEach(category => {
                let product = category.products.find(p => {
                    var _b, _j, _k, _q, _v;
                    return p.name.toLowerCase().includes(`${searchValue}`.toLowerCase()) ||
                        ((_b = p === null || p === void 0 ? void 0 : p.description) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(`${searchValue}`.toLowerCase())) ||
                        ((_j = p === null || p === void 0 ? void 0 : p.retail_barcode) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue ||
                        ((_k = p === null || p === void 0 ? void 0 : p.retail_barcode) === null || _k === void 0 ? void 0 : _k.toLowerCase().endsWith(`${searchValue}`.toLocaleLowerCase())) ||
                        p.name.toLowerCase().endsWith(`${searchValue}`.toLocaleLowerCase()) ||
                        ((_q = p === null || p === void 0 ? void 0 : p.retail_sku) === null || _q === void 0 ? void 0 : _q.toLowerCase()) == `${searchValue}` ||
                        ((_v = p === null || p === void 0 ? void 0 : p.oem) === null || _v === void 0 ? void 0 : _v.toLowerCase().includes(`${searchValue}`.toLowerCase()));
                });
                console.log(product);
                if (product) {
                    console.log(product === null || product === void 0 ? void 0 : product.name);
                    this.addToCart(product);
                    productFound = 1;
                }
            });
            if (productFound === 0) {
                toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
            }
            else {
                // Clear search input now that the product has been added
                this.clearSearch();
            }
        };
        this.handleSearchChange = (event) => {
            const query = event.currentTarget.value;
            const requestId = ++this.searchRequestId;
            this.setState({ searchValue: query });
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            const normalizedQuery = query.trim();
            if (normalizedQuery.length < 2 || (/^\d+$/.test(normalizedQuery) && normalizedQuery.length >= 13)) {
                this.setState({ productSuggestions: [], isLoadingProductSuggestions: false });
                return;
            }
            this.setState({ isLoadingProductSuggestions: true });
            this.searchDebounceTimer = setTimeout(() => {
                httpService
                    .get(`products/search/suggestions?query=${encodeURIComponent(normalizedQuery)}`)
                    .then((response) => {
                    var _b, _j;
                    if (requestId !== this.searchRequestId)
                        return;
                    this.setState({
                        productSuggestions: (_j = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _j !== void 0 ? _j : [],
                        isLoadingProductSuggestions: false
                    });
                });
            }, 250);
        };
        this.selectProductSuggestion = (product) => {
            this.addToCart(product);
            this.clearSearch();
        };
        this.clearSearch = () => {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.searchRequestId++;
            this.setState({
                searchValue: null,
                productSuggestions: [],
                isLoadingProductSuggestions: false
            });
            let searchInput = document.getElementById('barcode-input');
            if (searchInput) {
                searchInput.value = '';
                searchInput.focus();
            }
        };
        this.handleVatTypeChange = (event) => {
            this.setState({ vatType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.handleSelectItem = (e) => {
            console.log(e.currentTarget.value);
            let categoryTemp = this.state.categories.find(category => category.id === e.currentTarget.value);
            if (categoryTemp === null || categoryTemp === void 0 ? void 0 : categoryTemp.id) {
                this.categoryClick(categoryTemp);
            }
        };
        this.handleCustomerSearchChange = (event) => {
            var rawValue = event.currentTarget.value;
            var searchQuery = rawValue.trim();
            this.setState({ customerSearch: rawValue });
            if (!searchQuery) {
                this.setState({ customers: [] });
                return;
            }
            httpService
                .get(`/customers/search/all?query=${searchQuery}`)
                .then((response) => {
                this.setState({ customers: response.data.data });
            })
                .finally(() => { });
        };
        this.setCustomer = (customer) => {
            this.setState({ customer: customer });
        };
        this.closeModal = (id) => {
            const createModal = document.querySelector(`#${id}`);
            if (createModal) {
                var modalInstance = Modal.getInstance(createModal);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        };
        this.fetchPreviousOrders = (customerId) => {
            this.setState({ loadingOrders: true });
            httpService
                .get(`/customers/${customerId}/all-orders`)
                .then((response) => {
                var _b;
                if (((_b = this.state.customer) === null || _b === void 0 ? void 0 : _b.id) !== customerId)
                    return;
                this.setState({
                    previousOrders: response.data.data || []
                });
            })
                .finally(() => {
                var _b;
                if (((_b = this.state.customer) === null || _b === void 0 ? void 0 : _b.id) === customerId) {
                    this.setState({ loadingOrders: false });
                }
            });
        };
        this.fetchCustomerProductHistory = (customerId, productId) => {
            httpService.get(`/customers/${customerId}/products/${productId}/orders`).then((response) => {
                this.setState({
                    previousOrders: response.data.data
                });
            });
        };
        this.getAppSettings = () => {
            return JSON.parse(this.props.settings);
        };
        this.getCarTypes = () => {
            return JSON.parse(this.props.cartypes);
        };
        this.currencyFormatValue = (number) => {
            var settings = this.getAppSettings();
            return currency_format(number, settings.currencyPrecision, settings.currencyDecimalSeparator, settings.currencyThousandSeparator, settings.currencyPosition, settings.currencySymbol, settings.trailingZeros);
        };
        this.receiptExchangeRate = () => {
            var settings = this.getAppSettings();
            var value = Number(this.state.total) * Number(settings.exchangeRate);
            return currency_format(value, 2, '.', ',', 'before', settings.exchangeCurrency, true);
        };
        this.isProductAvailable = (product) => {
            if (product.continue_selling_when_out_of_stock)
                return true;
            if (!product.track_stock)
                return true;
            if (product.in_stock > 0)
                return true;
            return false;
        };
        this.updateItemQuantity = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.getRemainingStock = (item) => {
            return Math.max(Number(item.in_stock || 0) - Number(item.quantity || 0), 0);
        };
        this.updateItemVatType = (item) => {
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            _prod.vat_type = item.vat_type === 'exclude' ? 'add' : 'exclude';
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemVAT = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.tax_rate = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemDiscount = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.discount = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.createCustomer = (e) => {
            e.preventDefault();
            if (!this.state.customerName) {
                toast.error(t('Customer name is required!', 'اسم الزبون مطلوب!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/customers/create-new`, {
                name: this.state.customerName,
                email: this.state.customerEmail,
                mobile: this.state.customerMobile,
                city: this.state.customerCity,
                car_type_id: this.state.customerCarTypeId,
                car_name: this.state.customerCarName,
                car_chassis_number: this.state.customerCarChassisNumber,
                building: this.state.customerBuilding,
                street_address: this.state.customerStreet,
                floor: this.state.customerFloor,
                apartment: this.state.customerApartment
            })
                .then((response) => {
                this.setCustomer(response.data.data);
                this.fetchPreviousOrders(response.data.data.id);
                this.setState({ customerName: '' });
                this.setState({ customerEmail: '' });
                this.setState({ customerMobile: '' });
                this.setState({ customerCarTypeId: '' });
                this.setState({ customerCarName: '' });
                this.setState({ customerCarChassisNumber: '' });
                this.setState({ customerBuilding: '' });
                this.setState({ customerStreet: '' });
                this.setState({ customerFloor: '' });
                this.setState({ customerApartment: '' });
                var form = document.getElementById('create-customer-form');
                if (form) {
                    form.reset();
                }
                this.closeModal('customerModal');
                toast.info(t('Customer has been created', 'تم إنشاء زبون جديد'));
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.handleCustomerNameChange = (event) => {
            this.setState({ customerName: event.currentTarget.value });
        };
        this.handleCustomerEmailChange = (event) => {
            this.setState({ customerEmail: event.currentTarget.value });
        };
        this.handleCustomerMobileChange = (event) => {
            this.setState({ customerMobile: event.currentTarget.value });
        };
        this.handleCustomerCityChange = (event) => {
            this.setState({ customerCity: event.currentTarget.value });
        };
        this.handleCustomerCarTypeChange = (event) => {
            this.setState({ customerCarTypeId: event.currentTarget.value });
        };
        this.handleCustomerCarNameChange = (event) => {
            this.setState({ customerCarName: event.currentTarget.value });
        };
        this.handleCustomerCarChassisNumberChange = (event) => {
            this.setState({ customerCarChassisNumber: event.currentTarget.value });
        };
        this.handleCustomerStreetChange = (event) => {
            this.setState({ customerStreet: event.currentTarget.value });
        };
        this.handleCustomerBuildingChange = (event) => {
            this.setState({ customerBuilding: event.currentTarget.value });
        };
        this.handleCustomerFloorChange = (event) => {
            this.setState({ customerFloor: event.currentTarget.value });
        };
        this.handleCustomerApartmentChange = (event) => {
            this.setState({ customerApartment: event.currentTarget.value });
        };
        this.printInvoice = (orderId) => {
            const invoiceUrl = `${this.state.isQuotation ? 'quotations' : 'orders'}/print/${orderId}`; // Adjust the URL based on your Blade route
            window.open(invoiceUrl, '_blank');
        };
        this.printGovernmentInvoice = (orderId) => {
            if (this.state.isQuotation) {
                return;
            }
            if (orderId) {
                window.open(`/orders/government-invoice/${orderId}`, '_blank');
                return;
            }
            // The checkout button must save and print the current cart, not reuse
            // the order ID from the previous checkout.
            this.storeOrder('government');
        };
        this.modalCloseButton = () => {
            return React.createElement("button", { type: "button", className: "btn-close", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.modalCloseButtonWhite = () => {
            return React.createElement("button", { type: "button", className: "btn-close btn-close-white", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.handleOrderTypeChange = (event) => {
            this.setState({ orderType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.isOrderDelivery = () => {
            return this.state.orderType == 'delivery';
        };
        this.allProducts = () => {
            var products = [];
            this.state.categories.map((category) => {
                category.products.map((product) => {
                    products.push(product);
                });
            });
            return products;
        };
        this.handleCloseModal = () => {
            this.closeModal('checkoutModal');
        };
        this.handleIsQuotationChange = (event) => {
            this.setState({
                isQuotation: event.target.value == 'Quotation'
            });
        };
        this.pricesFilter = () => {
            return (React.createElement("div", { className: "dropdown" },
                React.createElement("button", { type: "button", className: "nav-link bg-white border px-3 py-2 rounded-3 clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#myModal" },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "me-5" }, priceFilterList[this.state.currentPrice]),
                            React.createElement(ChevronDownIcon, { className: "hero-icon-xs" }))))));
        };
        this.handleSelectRadio = (index) => {
            const cart = this.state.cart.map((item) => {
                let cartItem = {
                    cartId: uuid(),
                    id: item.id,
                    name: item.name,
                    full_name: item.full_name,
                    description: item.description,
                    image_url: item.image_url,
                    price: index === 0 ? item.retailsale_price : item.wholesale_price,
                    wholesale_price: item.wholesale_price,
                    retailsale_price: item.retailsale_price,
                    // barcode: item.barcode,
                    wholesale_barcode: item.wholesale_barcode,
                    retail_barcode: item.retail_barcode,
                    // sku: item.sku,
                    wholesale_sku: item.wholesale_sku,
                    retail_sku: item.retail_sku,
                    in_stock: item.in_stock,
                    track_stock: item.track_stock,
                    continue_selling_when_out_of_stock: item.continue_selling_when_out_of_stock,
                    quantity: 1,
                    vat_type: item.vat_type,
                    discount: item.discount,
                    tax_rate: item.tax_rate,
                    cost: item.cost
                };
                return cartItem;
            });
            this.setState({ cart: cart, currentPrice: index }, () => {
                this.calculateTotal();
            });
            this.closeModal('myModal');
        };
        this.pricesFilterModal = () => {
            return (React.createElement("div", { className: "modal zoom-out-entrance", id: "myModal", tabIndex: -1, "aria-labelledby": "myModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(0) },
                                React.createElement("div", null, priceFilterList[0]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 0 }))),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("div", { className: "d-flex justify-content-between user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(1) },
                                React.createElement("div", null, priceFilterList[1]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 1 }))),
                        React.createElement("div", { className: "modal-footer" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(2) },
                                React.createElement("div", null, priceFilterList[2]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 2 })))))));
        };
        this.handleServiceChange = (event) => {
            this.setState({ selectedService: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.getSelectedService = () => {
            return this.state.services.find((s) => String(s.id) === String(this.state.selectedService));
        };
        this.printReport = () => {
            const printContent = document.getElementById('previousOrdersReport');
            if (!printContent)
                return;
            const newWin = window.open('', '', 'width=900,height=700');
            if (!newWin)
                return;
            newWin.document.write('<html><head><title>Customer Product Report</title>');
            newWin.document.write('<style>');
            newWin.document.write(`
        body { font-family: Arial, sans-serif; padding: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 8px; text-align: left; }
        th { background-color: #f2f2f2; }
        .text-right { text-align: right; }
    `);
            newWin.document.write('</style>');
            newWin.document.write('</head><body>');
            newWin.document.write(printContent.innerHTML);
            newWin.document.write('</body></html>');
            newWin.document.close();
            newWin.onload = function () {
                newWin.focus();
                setTimeout(function () {
                    newWin.print();
                }, 500);
            };
            newWin.onafterprint = function () {
                newWin.close();
            };
        };
        this.state = {
            categories: [],
            products: [],
            cart: [],
            customers: [],
            customer: undefined,
            customerName: null,
            customerEmail: null,
            customerMobile: null,
            customerCity: null,
            customerBuilding: null,
            customerStreet: null,
            customerFloor: null,
            customerApartment: null,
            customerSearch: '',
            showProducts: false,
            categoryName: null,
            orderType: 'takeout',
            subtotal: 0,
            total: 0,
            tax: 0,
            vatType: this.getAppSettings().vatType,
            deliveryCharge: 0,
            hasaudio: true,
            discount: 0,
            searchValue: null,
            remarks: null,
            isFullScreen: isFullScreen(),
            tenderAmount: 0,
            returnAmount: 0,
            customerAmount: 0,
            isLoading: false,
            isLoadingCategories: true,
            selectItem: 'first',
            currentPrice: 0,
            isPaid: true,
            isQuotation: false,
            selectedService: null,
            services: [],
            services_m: [],
            customerCarTypeId: null,
            customerCarName: null,
            customerCarChassisNumber: null,
            previousOrders: [],
            loadingOrders: false,
            lastSavedOrderId: null,
            productSuggestions: [],
            isLoadingProductSuggestions: false
        };
    }
    componentDidMount() {
        var settings = this.getAppSettings();
        this.setState({ tax: settings.taxRate });
        this.setState({ deliveryCharge: settings.deliveryCharge });
        this.setState({ discount: settings.discount });
        this.setState({ hasaudio: settings.newItemAudio });
        this.setState({ vatType: settings.vatType });
        this.getCategories();
        this.getServices();
        this.calculateTotal();
        this.setState({ tenderAmount: this.state.total });
        window.onbeforeunload = event => {
            return 'Are you sure?';
        };
    }
    componentWillUnmount() {
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }
        this.searchRequestId++;
    }
    selectCustomer(customer) {
        this.setState({ customer: customer });
        console.log('Customer:', customer);
        console.log('Customer ID:', customer.id);
        this.fetchPreviousOrders(customer.id);
        this.closeModal('customerModal');
    }
    removeCustomer() {
        this.setState({ customer: undefined });
    }
    render() {
        var _b;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex py-3" },
                React.createElement("div", { className: "d-flex flex-grow-1" },
                    React.createElement("div", { className: "flex-grow-1 d-flex" },
                        React.createElement("button", { className: "btn btn-primary me-2", onClick: event => this.goToDashboard() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(Squares2X2Icon, { className: "hero-icon me-1" }),
                                " ",
                                t('Dashboard', 'الرئيسية'))),
                        React.createElement("button", { className: "btn btn-light me-3 bg-white border", "data-bs-toggle": "modal", "data-bs-target": "#customerModal" },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(UserCircleIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Customer', 'الزبون'))),
                        React.createElement("button", { className: "btn btn-danger me-5", onClick: event => this.reset() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(ArrowPathIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Reset?', 'إعادة ضبط'))),
                        React.createElement("select", { name: "is_quotation", id: "is_quotation", className: "form-select px-5", value: this.state.isQuotation ? 'Quotation' : 'Inovoice', defaultValue: "Inovoice", onChange: e => this.handleIsQuotationChange(e) },
                            React.createElement("option", { value: "Inovoice" }, t('Invoice', 'فاتورة')),
                            React.createElement("option", { value: "Quotation" }, t('Quotation', 'اقتباس'))),
                        React.createElement("select", { name: "service", id: "service", className: "form-select px-5 ms-3", value: this.state.selectedService || '', onChange: e => this.handleServiceChange(e) },
                            React.createElement("option", { value: "" }, t('Select a Service', 'اختر الخدمة')),
                            Array.isArray(this.state.services) &&
                                this.state.services.map((service) => (React.createElement("option", { key: service.id, value: service.id },
                                    service.service_type,
                                    " - (Price: ",
                                    service.price,
                                    ")"))))),
                    this.pricesFilter(),
                    this.pricesFilterModal()),
                React.createElement("div", { className: "d-flex" }, this.getAppSettings().enableTakeoutAndDelivery && (React.createElement("select", { name: "order-type", id: "order-type", className: "form-select form-select-lg px-5", defaultValue: "takeout", onChange: e => this.handleOrderTypeChange(e) },
                    React.createElement("option", { value: "takeout" }, t('Takeout', 'أستلام')),
                    React.createElement("option", { value: "delivery" }, t('Delivery', 'توصيل')))))),
            React.createElement("div", { id: "previousOrdersReport" }, this.state.customer && (React.createElement("div", { className: "row mb-5" },
                React.createElement("div", { className: "col-md-12 text-right" },
                    React.createElement("button", { className: "btn btn-primary mb-3", onClick: this.printReport }, "Print Report")),
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("div", { className: "orders-container" },
                        this.state.loadingOrders && React.createElement("p", null, "Loading..."),
                        !this.state.loadingOrders && this.state.previousOrders.length === 0 && React.createElement("p", null, "No orders found."),
                        !this.state.loadingOrders &&
                            this.state.previousOrders.length > 0 &&
                            this.state.previousOrders.map((order) => (React.createElement("div", { key: order.id, className: "order-card mb-3 p-3 border rounded" },
                                React.createElement("div", { className: "order-header mb-2" },
                                    React.createElement("strong", null, "Invoice:"),
                                    " ",
                                    order.number,
                                    " ",
                                    React.createElement("br", null),
                                    React.createElement("strong", null, "Date:"),
                                    " ",
                                    order.created_at,
                                    " ",
                                    React.createElement("br", null),
                                    React.createElement("strong", null, "Author:"),
                                    " ",
                                    order.author_name,
                                    " ",
                                    React.createElement("br", null)),
                                React.createElement("table", { className: "table table-sm table-bordered" },
                                    React.createElement("thead", null,
                                        React.createElement("tr", null,
                                            React.createElement("th", null, "Product"),
                                            React.createElement("th", null, "Qty"),
                                            React.createElement("th", null, "Price"),
                                            React.createElement("th", null, "Total"))),
                                    React.createElement("tbody", null,
                                        order.order_details && order.order_details.length > 0 ? (order.order_details.map((item, index) => {
                                            var _b;
                                            return (React.createElement("tr", { key: index },
                                                React.createElement("td", null, ((_b = item.product) === null || _b === void 0 ? void 0 : _b.name) || ''),
                                                React.createElement("td", null, item.quantity),
                                                React.createElement("td", null, item.price),
                                                React.createElement("td", null, item.total)));
                                        })) : (React.createElement("tr", null,
                                            React.createElement("td", { colSpan: 4, className: "text-center" }, "No items found"))),
                                        React.createElement("tr", null,
                                            React.createElement("td", null),
                                            React.createElement("td", null),
                                            React.createElement("td", { className: "text-right" },
                                                React.createElement("div", null, "Discount: "),
                                                React.createElement("div", null, "Delivery: "),
                                                React.createElement("div", null, "Subtotal: "),
                                                React.createElement("div", null,
                                                    React.createElement("b", null, "Total: ")),
                                                React.createElement("div", null, "Paid: "),
                                                React.createElement("div", null, "Owe:")),
                                            React.createElement("td", null,
                                                React.createElement("div", null, order.discount_view),
                                                React.createElement("div", null, order.delivery_charge_view),
                                                React.createElement("div", null, order.subtotal_view),
                                                React.createElement("div", null,
                                                    React.createElement("b", null, order.total_view)),
                                                React.createElement("div", null, order.tender_amount_view),
                                                React.createElement("div", null, order.owe_view))))),
                                React.createElement("div", { className: "order-footer text-right" },
                                    React.createElement("div", null,
                                        "Discount: ",
                                        order.discount_view),
                                    React.createElement("div", null,
                                        "Owe: ",
                                        order.owe_view)))))))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white border-bottom-0 p-0" },
                            React.createElement("form", { onSubmit: event => this.handleSearchSubmit(event), className: "position-relative" },
                                React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0", style: { paddingRight: '2.5rem' }, name: "search", id: "barcode-input", placeholder: t('Scan barcode or search by name, OEM, barcode or SKU', 'امسح الباركود أو ابحث بالاسم أو OEM أو SKU'), onChange: event => this.handleSearchChange(event) }),
                                !!this.state.searchValue && (React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none position-absolute top-50 end-0 translate-middle-y me-3", onClick: () => this.clearSearch() })),
                                (this.state.isLoadingProductSuggestions || this.state.productSuggestions.length > 0) && (React.createElement("div", { className: "position-absolute start-0 end-0 top-100 bg-white shadow border", style: { zIndex: 1050, maxHeight: '20rem', overflowY: 'auto' } },
                                    this.state.isLoadingProductSuggestions && (React.createElement("div", { className: "px-3 py-2 text-muted" }, t('Searching...', 'جارٍ البحث...'))),
                                    this.state.productSuggestions.map(product => (React.createElement("button", { key: product.id, type: "button", className: "btn btn-light w-100 text-start rounded-0 border-bottom px-3 py-2", onClick: () => this.selectProductSuggestion(product) },
                                        React.createElement("span", { className: "d-block fw-bold" }, product.name),
                                        React.createElement("small", { className: "text-muted" }, [product.oem, product.retail_barcode, product.wholesale_barcode, product.retail_sku, product.wholesale_sku]
                                            .filter(Boolean)
                                            .join(' | '))))))))),
                        React.createElement("div", { className: "card-body p-0 overflow-auto", id: "cartItems" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 300, className: "p-3 fw-bold" }, t('Item', 'الصنف')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Quantity', 'الكمية')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('VAT', 'الضريبة'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('Discount', 'الخصم'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Total', 'المجموع')))),
                                React.createElement("tbody", null, this.state.cart.length > 0 ? (React.createElement(React.Fragment, null, this.state.cart.map((item) => {
                                    return (React.createElement("tr", { key: item.cartId },
                                        React.createElement("td", { width: 300 },
                                            React.createElement("div", { className: "d-flex mb-2" },
                                                React.createElement("div", { className: "d-flex flex-grow-1" },
                                                    React.createElement("div", { className: "me-2 d-flex align-items-center" },
                                                        React.createElement("img", { src: item.image_url, alt: "img", className: "rounded-2", height: 50 })),
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "fw-bold" },
                                                            item.description,
                                                            " - ",
                                                            item.full_name),
                                                        React.createElement("div", { className: "fw-normal" },
                                                            React.createElement("input", { type: "number", className: "form-control text-center", value: item.price, onFocus: e => e.target.select(), onChange: e => this.updateItemPrice(e, item) })),
                                                        React.createElement("div", { className: "fw-normal mt-1" },
                                                            t('Cost', 'التكلفة'),
                                                            ": ",
                                                            this.currencyFormatValue(item.cost || 0)))),
                                                React.createElement("div", { className: "me-auto d-flex align-items-center" },
                                                    React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeItem(item) })))),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) }),
                                            item.track_stock && (React.createElement("div", { className: "small mt-2 text-muted" },
                                                t('Remaining', 'المتبقي'),
                                                ": ",
                                                React.createElement("strong", null, this.getRemainingStock(item))))),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("div", { onClick: event => this.updateItemVatType(item) }, item.vat_type),
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.tax_rate, onFocus: e => e.target.select(), onChange: event => this.updateItemVAT(event, item) })),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.discount, onFocus: e => e.target.select(), onChange: event => this.updateItemDiscount(event, item) })),
                                        React.createElement("td", { width: 150, className: "text-center align-middle" }, this.calculateItemPrice(item))));
                                }))) : (React.createElement(React.Fragment, null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 5, className: "p-3 text-center align-middle fs-5" }, t('No items added...', 'لا توجد اصناف مضافة ...')))))))),
                        React.createElement("div", { className: " card-footer p-0 bg-white", id: "orderDetails" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 3, width: 200, className: "text-center align-end clickable-cell", onClick: this.togglePaidButton }, this.state.isPaid === true ? 'Paid' : 'Unpaid')),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200 },
                                            t('Customer', 'الزبون'),
                                            ":",
                                            ' ',
                                            this.state.customer ? React.createElement("span", { className: "fw-bold" }, this.state.customer.name) : 'N/A',
                                            this.state.customer && (React.createElement("div", { className: "float-end" },
                                                React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeCustomer() })))),
                                        React.createElement("td", { width: 200, className: "text-end" }, t('Subtotal', 'المجموع')),
                                        React.createElement("td", { width: 200, className: "align-middle text-center" }, this.currencyFormatValue(this.state.subtotal))),
                                    this.getSelectedService() && (React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle" },
                                            "Service Type: ",
                                            this.getSelectedService().service_type),
                                        React.createElement("td", { width: 200, className: "text-end align-middle" }, t('Service Price', 'سعر الخدمة')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle" }, this.currencyFormatValue(this.getSelectedService().price)))),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#deliveryChargeModal" }, this.getAppSettings().enableTakeoutAndDelivery ? (React.createElement(React.Fragment, null, this.isOrderDelivery() && (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge
                                                ? this.currencyFormatValue(this.state.deliveryCharge)
                                                : 'N/A')))) : (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge ? this.currencyFormatValue(this.state.deliveryCharge) : 'N/A'))),
                                        React.createElement("td", { width: 200, className: "text-end align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, t('Discount', 'الخصم')),
                                        React.createElement("td", { width: 200, className: "text-center text-danger align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, this.currencyFormatValue(this.state.discount || 0))),
                                    React.createElement("tr", { className: "alert-success" },
                                        this.state.vatType == 'add' ? (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            t('VAT', 'الضريبة'),
                                            " ",
                                            this.state.tax,
                                            "%: ",
                                            this.currencyFormatValue(this.getTotalTax()))) : (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            React.createElement("div", null,
                                                t('TAX.AMOUNT', 'قيمة الضريبة'),
                                                ": ",
                                                this.currencyFormatValue(this.getTaxAmount())),
                                            React.createElement("div", null,
                                                t('VAT', 'الضريبة'),
                                                " ",
                                                this.state.tax,
                                                "%: ",
                                                this.currencyFormatValue(this.getVat())))),
                                        React.createElement("td", { width: 200, className: "fw-bold text-end fs-5 align-middle" }, t('Total', 'الإجمالي')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle fw-bold fs-5" },
                                            React.createElement("div", null,
                                                " ",
                                                this.currencyFormatValue(this.state.total)),
                                            this.getAppSettings().showExchangeRateOnReceipt && React.createElement("div", null, this.receiptExchangeRate())))))),
                        React.createElement("button", { type: "button", className: "btn btn-success py-4 rounded-0 shadow-sm fs-3 btn-lg w-100", "data-bs-toggle": "modal", "data-bs-target": "#checkoutModal" }, t('CHECKOUT', 'الدفع')))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white" },
                            React.createElement("div", { className: "d-flex px-4 justify-content-between align-items-center", style: { minHeight: 'calc(1.5em + 1rem + 5px)', padding: '0.5rem' } },
                                React.createElement("div", { className: "d-flex align-items-center" },
                                    React.createElement("a", { className: "text-decoration-none cursor-pointer pe-2 fs-5", onClick: event => this.backClick() }, t('CATEGORIES', 'الفئات')),
                                    this.state.showProducts && (React.createElement("div", { className: "d-flex align-items-center" },
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" })),
                                        React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, this.state.categoryName),
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" }))))),
                                React.createElement("select", { name: "product", className: "form-control w-50", value: this.state.selectItem, onChange: e => this.handleSelectItem(e) },
                                    React.createElement("option", { value: "first" }, "Select item"),
                                    this.state.categories.length > 0 &&
                                        this.state.categories.map((item) => React.createElement("option", { value: item.id }, item.name))))),
                        React.createElement("div", { className: "card-body overflow-auto py-0" },
                            this.state.isLoadingCategories && (React.createElement("div", { className: "py-5" },
                                React.createElement("div", { className: "d-flex justify-content-center m-2" },
                                    React.createElement("div", { className: "spinner-border text-primary", role: "status", style: { width: '4rem', height: '4rem' } },
                                        React.createElement("span", { className: "visually-hidden" }, t('Loading...', 'جاري التحميل...')))),
                                React.createElement("div", { className: "fw-bold h3 text-center" }, t('Loading...', 'جاري التحميل...')))),
                            !this.state.showProducts && (React.createElement(React.Fragment, null, this.state.categories.length > 0 && (React.createElement("div", { className: "row" }, this.state.categories.map((category) => {
                                return (React.createElement("div", { key: category.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.categoryClick(category) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: category.image_url }),
                                            React.createElement("img", { alt: category.name, src: category.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "product-name", dir: "auto" }, category.name)))));
                            }))))),
                            this.state.showProducts && (React.createElement(React.Fragment, null, this.state.products.length > 0 && (React.createElement("div", { className: "row overflow-auto" }, this.state.products.map((product) => {
                                return (React.createElement(React.Fragment, null, this.isProductAvailable(product) && (React.createElement("div", { key: product.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.addToCart(product) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: product.image_url }),
                                            React.createElement("img", { alt: product.name, src: product.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "fw-normal" }, this.currencyFormatValue((this.state.currentPrice === 0
                                                ? product.retailsale_price
                                                : product.wholesale_price) || 0)),
                                            React.createElement("div", { className: "fw-bold", dir: "auto" }, product.full_name),
                                            React.createElement("div", { className: "fw-normal" }, product.in_stock),
                                            React.createElement("div", { className: "fw-normal", dir: "auto" }, product.description)))))));
                            }))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "discountModal", tabIndex: -1, "aria-labelledby": "discountModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "discountModalLabel" }, t('Discount', 'الخصم')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.discount || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.discount, onChange: this.handleDiscountChange })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "deliveryChargeModal", tabIndex: -1, "aria-labelledby": "deliveryChargeModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "deliveryChargeModalLabel" }, t('Delivery Charge', 'رسوم التوصيل')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.deliveryCharge || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.deliveryCharge, onChange: this.handleDeliveryChargeChange, onFocus: e => e.target.select() })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "taxModal", tabIndex: -1, "aria-labelledby": "taxModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "taxModalLabel" }, t('VAT', 'الضريبة')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" },
                                this.state.tax || 0,
                                "%"),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.tax, onChange: this.handleTaxChange })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("select", { name: "vatType", id: "vat-type", className: "form-select form-select-lg", onChange: this.handleVatTypeChange, value: this.state.vatType },
                                    React.createElement("option", { value: "exclude" },
                                        " ",
                                        t('Exclude', 'استثناء')),
                                    React.createElement("option", { value: "add" }, t('Add', 'إضافة')))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "customerModal", tabIndex: -1, "aria-labelledby": "customerModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "customerModalLabel" }, t('Customer', 'الزبون')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body p-0" },
                            React.createElement("nav", null,
                                React.createElement("div", { className: "nav nav-tabs nav-justified", id: "nav-tab", role: "tablist" },
                                    React.createElement("button", { className: "nav-link rounded-0 active", id: "nav-search-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-search-customer", type: "button", role: "tab", "aria-controls": "nav-search-customer", "aria-selected": "true" }, t('Search', 'ابحث')),
                                    React.createElement("button", { className: "nav-link rounded-0", id: "nav-create-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-create-customer", type: "button", role: "tab", "aria-controls": "nav-create-customer", "aria-selected": "false" }, t('Create', 'إنشاء')))),
                            React.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                                React.createElement("div", { className: "tab-pane fade show active", id: "nav-search-customer", role: "tabpanel", "aria-labelledby": "nav-search-customer-tab", tabIndex: 0 },
                                    React.createElement("div", { className: "position-relative w-100" },
                                        React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0 shadow-none", name: "search", id: "search", autoComplete: "off", value: this.state.customerSearch, placeholder: t('Search...', 'بحث...'), onChange: event => this.handleCustomerSearchChange(event) })),
                                    React.createElement("div", { className: "overflow-auto", style: { height: '250px' } }, this.state.customers.length > 0 && (React.createElement(React.Fragment, null, this.state.customers.map((cuts) => {
                                        return (React.createElement("div", { className: "py-2 px-3 clickable-cell border-bottom", onClick: e => this.selectCustomer(cuts), key: cuts.id },
                                            React.createElement("div", { className: "fw-bold" }, cuts.name),
                                            React.createElement("div", { className: "small text-muted" }, cuts.contact),
                                            React.createElement("div", { className: "small text-muted" }, cuts.full_address)));
                                    }))))),
                                React.createElement("div", { className: "tab-pane fade p-3", id: "nav-create-customer", role: "tabpanel", "aria-labelledby": "nav-create-customer-tab", tabIndex: 0 },
                                    React.createElement("form", { method: "POST", onSubmit: this.createCustomer, role: "form", id: "create-customer-form" },
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" },
                                                t('Customer Name', 'اسم الزبون'),
                                                "*"),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerNameChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Email', 'البريد الإلكتروني')),
                                            React.createElement("input", { type: "email", className: "form-control form-control-lg", onChange: event => this.handleCustomerEmailChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Mobile Number', 'رقم الجوال')),
                                            React.createElement("input", { type: "tel", className: "form-control form-control-lg", onChange: event => this.handleCustomerMobileChange(event) })),
                                        React.createElement("div", { className: "text-muted" }, t('Address', 'العنوان')),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('City', 'المدينة')),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCityChange(event) })),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Street', 'الشارع')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerStreetChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Building', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerBuildingChange(event) }))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Floor', 'الطابق')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerFloorChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Apartment', 'الشقة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerApartmentChange(event) }))),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Car Type', 'الشارع')),
                                            React.createElement("select", { name: "car_type_id", id: "car_type_id", className: "form-select px-5 ms-3", value: this.state.customerCarTypeId || '', onChange: event => this.handleCustomerCarTypeChange(event) },
                                                React.createElement("option", { value: "" }, t('Select a Car Type', 'اختر الخدمة')),
                                                Array.isArray(this.getCarTypes()) &&
                                                    this.getCarTypes().map((cartype) => (React.createElement("option", { key: cartype.id, value: cartype.id }, cartype.type))))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Car Name', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCarNameChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Car Chassis Number', 'المدينة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCarChassisNumberChange(event) }))),
                                        React.createElement("button", { className: "btn btn-primary btn-lg w-100", type: "submit", disabled: this.state.isLoading }, t('Create Customer', 'إنشاء زبون جديد'))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "checkoutModal", tabIndex: -1, "aria-labelledby": "checkoutModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered modal-lg" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "checkoutModalLabel" }),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body py-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-6 py-3 bg-primary-sec" },
                                    React.createElement("table", { className: "table table-borderless" },
                                        React.createElement("tbody", null,
                                            this.getSelectedService() && (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Service Charges', 'رسوم الخدمة')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getSelectedService().price)))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Subtotal', 'المجموع')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.subtotal))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Quantity', 'الكمية')),
                                                React.createElement("td", { className: "text-white" }, this.state.cart.reduce(function (prev, current) {
                                                    return prev + +(current.quantity || 0);
                                                }, 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Discount', 'الخصم')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.discount || 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Delivery Charge', 'رسوم التوصيل')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.deliveryCharge || 0))),
                                            this.state.vatType == 'add' ? (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    ' ',
                                                    t('VAT', 'الضريبة'),
                                                    " ",
                                                    this.state.tax || 0,
                                                    "%"),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTotalTax())))) : (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        " ",
                                                        t('Tax Amount', 'القيمة الضريبية')),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTaxAmount()))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        t('VAT', 'الضريبة'),
                                                        " ",
                                                        this.state.tax || 0,
                                                        "%"),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getVat()))))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Total', 'الإجمالي')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.total))),
                                            this.state.customer && (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" },
                                                        " ",
                                                        t('Customer', 'الزبون')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.name)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Contact', 'الاتصال')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.contact)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Address', 'العنوان')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.full_address)))))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "remarks", className: "form-label text-danger-sec" }, t('Notes', 'الملاحظات')),
                                        React.createElement("textarea", { className: "form-control", id: "remarks", rows: 3, onChange: event => this.handleRemarksChange(event) }, this.state.remarks))),
                                React.createElement("div", { className: "col-6 py-3 bg-body d-flex flex-column" },
                                    React.createElement("div", { className: "text-center text-danger" },
                                        " ",
                                        t('CHECKOUT', 'الدفع')),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Tender Amount', 'المبلغ المدفوع')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_b = this.state.tenderAmount) === null || _b === void 0 ? void 0 : _b.toFixed(2), onFocus: e => e.target.select(), onChange: this.handleTenderAmountChange })),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Customer Amount', 'مبلغ العميل')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.customerAmount, onFocus: e => e.target.select(), onChange: this.handleCustomerAmountChange })),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" },
                                            " ",
                                            t('Return', 'مبلغ العميل')),
                                        React.createElement("div", { className: "form-label text-center" }, this.currencyFormatValue(this.state.returnAmount))),
                                    React.createElement("hr", null),
                                    React.createElement("table", { className: "table table-borderless d-none" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, this.getChangeAmount() < 0 ? t('Owe', 'مدين') : t('Change', 'الباقي')),
                                                React.createElement("td", { className: "text-end" }, this.currencyFormatValue(this.getChangeAmount()))))),
                                    React.createElement("div", { className: "mt-auto" },
                                        React.createElement("button", { className: "btn btn-primary btn-lg py-3 w-100", disabled: this.state.isLoading, onClick: e => this.storeOrder() }, t('SUBMIT', 'حفظ')),
                                        React.createElement("button", { type: "button", className: "btn btn-secondary btn-lg py-3 w-100 mt-2", disabled: this.state.isLoading || this.state.isQuotation, onClick: () => this.storeOrder('government') }, t('PRINT GOVERNMENT INVOICE', 'طباعة الفاتورة الحكومية'))))))))),
            React.createElement(ToastContainer, { position: "bottom-left", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default PointOfSale;
const element = document.getElementById('pos');
if (element) {
    const props = Object.assign({}, element.dataset);
    const root = ReactDOM.createRoot(element);
    root.render(React.createElement(PointOfSale, Object.assign({ settings: props.settings || '', services: props.services ? JSON.parse(props.services) : [], cartypes: props.cartypes ? JSON.parse(props.cartypes) : [] }, props)));
}
